import { FC } from 'react';
import { GalleryThumbnailProps } from '@/components/common/Gallery/types';
import { SliderThumbnailIcon, SliderThumbnailImage } from '@/components/common/Gallery/styles';
import Icon from '@/units/Icon';

export const GalleryThumbnail: FC<GalleryThumbnailProps> = ({ item, active = false, thumbnailsGap = 0, onPointerUp = () => {}, thumbnailIconBackground, thumbnailSize, isNotesGallery, inFullScreen = false,  thumbnailBorderColor}) => {

  if (item.endsWith('.jpg') || item.endsWith('.png') || item.endsWith('.gif') || item.endsWith('.webp')) {
    return <SliderThumbnailImage src={item} active={active} marginRight={thumbnailsGap} onPointerUp={onPointerUp} thumbnailSize={thumbnailSize}/>;
  }

  if (item.endsWith('.mp4') || item.endsWith('.webm') || item.endsWith('.ogg')) {
    return (
      <SliderThumbnailIcon active={active} marginRight={thumbnailsGap} onPointerUp={onPointerUp} background={thumbnailIconBackground} thumbnailSize={thumbnailSize} thumbnailBorderColor={thumbnailBorderColor} isNotesGallery={isNotesGallery} inFullScreen={inFullScreen}>
          <Icon.Video {...(isNotesGallery && !inFullScreen && { stroke: "#000000" })} />
      </SliderThumbnailIcon>
    );
  }

  if (item.includes('youtube.com') || item.includes('vimeo.com') || item.endsWith('.pdf')) {
    return (
      <SliderThumbnailIcon active={active} marginRight={thumbnailsGap} onPointerUp={onPointerUp} background={thumbnailIconBackground} thumbnailSize={thumbnailSize} thumbnailBorderColor={thumbnailBorderColor} isNotesGallery={isNotesGallery} inFullScreen={inFullScreen}>
        {item.endsWith('.pdf') ? <Icon.Document {...(isNotesGallery && !inFullScreen && { stroke: "#000000" })} /> : <Icon.Video {...(isNotesGallery && !inFullScreen && { stroke: "#000000" })} />}
      </SliderThumbnailIcon>
    );
  }

  return (
    <div style={{ width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', backgroundColor: 'gray' }}>
      <p>Unsupported content type</p>
    </div>
  );
};
